export default "__VITE_ASSET__5cT09eD6__"